import { useDispatch, useSelector } from 'react-redux'
import { startExperience } from '@/store/reducers/progressReducer'

import './SplashScreen.scss'

import beginImg from '/png/begin.png'
import beginGif from '/gif/begin.gif'
import headphonesGif from '/gif/headphones.gif'
import { useState } from 'react'

export default function SplashScreen() {
  const dispatch = useDispatch()
  const { hasStarted } = useSelector((state) => state.progress)

  const [isButtonHovered, setIsButtonHovered] = useState(false)

  function onButtonClick() {
    dispatch(startExperience())
  }

  return (
    <>
      <div
        className={`c-splash-screen ${hasStarted ? '-has-started' : ''}`}
        onClick={() => onButtonClick()}
      >
        <header className="c-splash-screen-header">
          <div className="c-splash-screen-header__headphones">
            <img src={headphonesGif} />
            <p>Un casque audio est recommandé</p>
          </div>
          <h1 className="c-splash-screen-header__title">
            <img src={`/svg/logo.svg`} />
          </h1>
          <button
            className="c-splash-screen-header__button"
            onPointerEnter={() => setIsButtonHovered(true)}
            onPointerLeave={() => setIsButtonHovered(false)}
          >
            <img src={isButtonHovered ? beginGif : beginImg} />
          </button>
        </header>
      </div>
    </>
  )
}
